/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {TSSerializable} from './TSSerializable';
import TSAbstractBemerkungEntity from './TSAbstractBemerkungEntity';
import TSBenutzer from './TSBenutzer';
import {TSBemerkungScope} from './enums/TSBemerkungScope';
import moment from 'moment';
import {TSSchadenfallStatus} from './enums/TSSchadenfallStatus';
import {begruendungsCodePrefix, begruendungsCodeShortPostfix, TSBegruendungsCode} from './enums/TSBegruendungsCode';

export default class TSTransitionBemerkung extends TSAbstractBemerkungEntity implements TSSerializable<TSTransitionBemerkung> {

    private _besitzer: TSBenutzer | undefined;

    private _scope: TSBemerkungScope;

    private _preStatus: TSSchadenfallStatus;

    private _postStatus: TSSchadenfallStatus;

    private _begruendungsCode: TSBegruendungsCode;

    public get besitzer(): TSBenutzer | undefined {
        return this._besitzer;
    }

    public set besitzer(value: TSBenutzer | undefined) {
        this._besitzer = value;
    }

    public get scope(): TSBemerkungScope {
        return this._scope;
    }

    public set scope(value: TSBemerkungScope) {
        this._scope = value;
    }

    public get preStatus(): TSSchadenfallStatus {
        return this._preStatus;
    }

    public set preStatus(value: TSSchadenfallStatus) {
        this._preStatus = value;
    }

    public get postStatus(): TSSchadenfallStatus {
        return this._postStatus;
    }

    public set postStatus(value: TSSchadenfallStatus) {
        this._postStatus = value;
    }

    public get begruendungsCode(): TSBegruendungsCode {
        return this._begruendungsCode;
    }

    public set begruendungsCode(value: TSBegruendungsCode) {
        this._begruendungsCode = value;
    }

    deserialize(restObject: any): TSTransitionBemerkung {
        super.deserialize(restObject);
        this.scope = restObject.scope;
        this.besitzer = this.deserializeOrNull(restObject.besitzer, new TSBenutzer());
        this.begruendungsCode = restObject.begruendungsCode;
        this.postStatus = restObject.postStatus;
        this.preStatus = restObject.preStatus;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.scope = this.scope;
        restObject.besitzer = this.serializeOrInit(this.besitzer, restObject.besitzer);
        restObject.begruendungsCode = this.begruendungsCode;
        restObject.postStatus = this.postStatus;
        restObject.preStatus = this.preStatus;
        return restObject;
    }

    public static getDeserializer = (benutzerBemerkung: any) => {
        return new TSTransitionBemerkung().deserialize(benutzerBemerkung);
    };

    public static getSerializer = (benutzerBemerkung: any) => {
        return benutzerBemerkung.serialize(benutzerBemerkung);
    };

    public getBesitzerName(): string {
        if (this.besitzer && this.besitzer.getFullName()) {
            return this.besitzer.getFullName();
        }
        return ' '
    }

    getTimestampErstellt(): moment.Moment {
        if (this.timestampErstellt) {
            return this.timestampErstellt;
        }
        return moment();
    }

    getBemerkungScope(): TSBemerkungScope {
        return this.scope;
    }

    getBesitzer(): TSBenutzer | undefined {
        return this.besitzer;
    }

    getBegruendung(): string | undefined {
        if (this.begruendungsCode) {
            return begruendungsCodePrefix() + this.begruendungsCode + begruendungsCodeShortPostfix();
        }
        return undefined;
    }

    getPreStatus(): TSSchadenfallStatus | undefined {
        return this.preStatus;
    }

    getPostStatus(): TSSchadenfallStatus | undefined {
        return this.postStatus;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSTransitionBemerkung.ts